module.exports = __webpack_public_path__ + "fonts/jj2 bd.5e1a3b4c.otf";